import type { LocationQuery, RouteLocationRaw } from 'vue-router'

import { parse as parseHash } from '@backmarket/utils/query-string/parse'
import { stringify as stringifyHash } from '@backmarket/utils/query-string/stringify'

const MIN_PRODUCTS_FOR_FILTERED_PAGE = 2

type RouteContext = {
  path: string
  query: LocationQuery
  hash: string
}

export function getUnknownQueryKeyRedirect(
  { path, query, hash }: RouteContext,
  openFilterKey: string | null,
  hasOpenFacetsError: boolean,
  allFacetKeys: string[] = [],
): RouteLocationRaw | null {
  if (hasOpenFacetsError) return null

  const hasUnwantedFacetKey = Object.keys(query).some(
    (key) => allFacetKeys.includes(key) && key !== openFilterKey,
  )
  if (!hasUnwantedFacetKey) return null

  const cleanQuery: LocationQuery = {}
  for (const [key, value] of Object.entries(query)) {
    if (!allFacetKeys.includes(key) || key === openFilterKey) {
      cleanQuery[key] = value
    }
  }

  return { path, query: cleanQuery, hash }
}

export function getOpenFilterHashRedirect(
  { path, query, hash }: RouteContext,
  openFilterKey: string | null,
): RouteLocationRaw | null {
  if (!openFilterKey) return null

  const currentHashFilters = hash ? parseHash(hash.replace(/^#/, '')) : {}
  if (!(openFilterKey in currentHashFilters)) return null

  const { [openFilterKey]: _dropped, ...rest } = currentHashFilters
  const newHashBody = stringifyHash(rest)

  return { path, query, hash: newHashBody ? `#${newHashBody}` : '' }
}

export function getThinResultsRedirect(
  { path, query, hash }: RouteContext,
  openFilterKey: string | null,
  total: number,
): RouteLocationRaw | null {
  if (!openFilterKey || total >= MIN_PRODUCTS_FOR_FILTERED_PAGE) return null

  const { [openFilterKey]: _dropped, ...restQuery } = query

  return { path, query: restQuery, hash }
}
